// extracted by mini-css-extract-plugin
export default {"cls1":"Kw7tLQa3xZ1ZKG0kNE99","cls2":"hnvWqxgrjB7pYLJ7uQ9w Kw7tLQa3xZ1ZKG0kNE99"};